import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.c_alert_reports.a_index', () => {
  import('./internal/c_alert_reports__a_index').then(({ default: Component }) => Component());
});
